import XLSX from 'xlsx';


export default class JsUtils {

	/**
	 * 주어진 목록(_items)에서 id 항목들에 대한 하나의 문자열(,로 구분)을 만들어 리턴한다
	 */
	static getIds (_items) {
		var ids = '';
		for(var i=0; i < _items.length; i++) {
			if(ids != '') {
				ids = ids + ',' + _items[i].id;
			}
			else {
				ids = _items[i].id;
			}
		}
		return ids;
	}

	/**
	 * Dropdown 목록에 사용여부 목록을 만든다 (전체, Y, N)
	 */
	static yns(allYn){
		var yn;

		if(allYn) {
			yn = [{label:'전체선택', value:null}, {label:'Y', value:true}, {label:'N', value:false}];
		} else {
			yn = [{label:'Y', value:true}, {label:'N', value:false}];
		}
		
		return yn;
	}

	/**
	 * 주어진 데이터(_data)에서 필수 입력 항목들(_columns)이 비워있는 지 체크한다
	 */
	static checkUndefineColumns(_data,_columns){    
        for(var i=0 ; i <_columns.length;i++)
        {
			//console.log(_data[_columns[i]]);
			if (_data[_columns[i]] == null || _data[_columns[i]].toString() == "")
                return false;
        }          
		return true;
	}

	/**
	 * 주어진 데이터(_data)에서 필수 입력 항목들(_columns)이 비워있는 지 체크한다
	 */
	static checkUndefineColumns2(_data,_columns){    
		let errMsg = null;
        for(var i=0 ; i <_columns.length;i++)
        {
			if (_data[_columns[i]] == null || _data[_columns[i]].toString() == "") {
				if(errMsg == null)
					errMsg = _columns[i];
				else 
					errMsg += ", "+ _columns[i];
			}			
		}				
        return errMsg;
	}
	
	/**
	 * 주어진 데이터(_data)에서 필수 입력 항목들(_columns)이 비워있는 지 체크한다
	 */
	static checkUndefineColumns3(_data,_columns,){    
		let errMsg = null;
        for(var i=0 ; i <_columns.length;i++)
        {
			if (_data[_columns[i].field] == null || _data[_columns[i].field].toString() == "") {
				if(errMsg == null)
					errMsg = _columns[i].header;
				else 
					errMsg += ", "+ _columns[i].header;
			}			
		}				
        return errMsg;
	}

	/**
	 * DB로부터 얻어온 리스트(list)타입의 데이터를 트리 구조의 데이터를 리턴한다
	 */
	static toTreeData(list)
	{
		return JsUtils.getTreeData(0, list);  // 메뉴테이블에서 상위메뉴Id 컬럼의 값에 따라 0 or null 사용한다
	}

	/**
	 * DB로부터 얻어온 리스트(list)타입의 데이터를 트리 구조의 메뉴 데이터를 리턴한다
	 */
	static getTreeData (menuSeq, list)
	{
		var data = []; 
		list.forEach(e => {
			if(menuSeq == e.upperSeq)  // 메뉴의 id (pk)
			{
				var child = JsUtils.getTreeData(e.menuSeq, list);
				var temp = {key:e.menuSeq, data:e, children:child};
				data.push(temp);
			}
		})
		return data;
	}

	/**
	 * DB로부터 얻어온 리스트(list)타입의 데이터를 트리 구조의 Bom 데이터를 리턴한다
	 */
	static toBomTreeData(list)
	{
		return JsUtils.getBomTreeData(null,list);
	}

	/**
	 * DB로부터 얻어온 리스트(list)타입의 데이터를 Bom 트리 구조의 데이터를 리턴한다
	 */
	static getBomTreeData (id, list)
	{
		var data = []; 
		list.forEach(e => {
			if(id == e.sortUpItemId)
			{
				var child = JsUtils.getBomTreeData(e.sortItemId,list);
				var temp = {key:e.sortItemId,data:e,children:child};
				data.push(temp);
			}
		})
		return data;
	}

	/**
	 * PrimeVue의  Calendar를 이용하여 날짜를 선택하는 경우, 선택한 날짜를 문자열(yyyy-mm-dd)로 리턴한다
	 */
	static fixUTCDate (date) 
	{
		if (date) {
			var offset = date.getTimezoneOffset()
			date = new Date(date.getTime() - (offset*60*1000))
			return date.toISOString().split('T')[0]
		}
		return null;
	}

	/**
	 * Calendar에서 선택한 날짜 또는 문자열을 '2022-12-01' 형식으로 리턴한다
	 */
	static convertDateToString (date) {
		if(date != null){
			if(typeof date == 'object') {  // ex) 2019-12-31T15:00:00.000
				return JsUtils.fixUTCDate(new Date(date));
			}
			else {  // string인 경우 ex) 2022-12-01
				return date;
			}
		}
		return null;
	}

	/**
	 * Calendar에서 선택한 날짜 또는 문자열을 '20221201' 형식으로 리턴한다
	 */
	static convertDateToString2 (date) {
		if(date != null){
			if(typeof date == 'object') {
				var _date = JsUtils.fixUTCDate(new Date(date));
				return _date.replace(/-/gi, "");
			}
			else {  // string인 경우 2022-12-01  --> 20221201
				if(date.length == 10) {
					return date.replace(/-/gi, "");
				}
			}
		}
		return null;
	}

	/**
	 * Calendar에서 선택한 날짜 또는 문자열을 '2022-12' 형식으로 리턴한다
	 */
	static convertYmToString (date) {
		if(date != null){
			var ym = null;
			if(typeof date == 'object') {  // ex) 2019-12-31T15:00:00.000
				ym = JsUtils.fixUTCDate(new Date(date));
			}
			else {  // string인 경우 ex) 2022-12-01
				ym = date;
			}
			
			var sYear = ym.substring(0,4);
			var sMonth = ym.substring(5,7);
			return sYear + '-' + sMonth;
		}
		return null;
	}

	/**
	 * Calendar에서 선택한 날짜 또는 문자열을 '2022' 형식으로 리턴한다
	 */
	static convertYYToString (date) {
		if(date != null){
			var ym = null;
			if(typeof date == 'object') {  // ex) 2019-12-31T15:00:00.000
				ym = JsUtils.fixUTCDate(new Date(date));
			}
			else {  // string인 경우 ex) 2022-12-01
				ym = date;
			}
			
			var sYear = ym.substring(0,4);
			return sYear;
		}
		return null;
	}

	/**
	 * 날짜(Date)를 MariaDB에서 사용한느 time 타입으로 변경한다
	 */
	static getMariaDBtime (date)
	{
		if (date) {
			var offset = date.getTimezoneOffset()
			date = new Date(date.getTime() - (offset*60*1000))

			//2022-05-18T17:57:40.839Z의 형식으로 처리후 java 단에서 private Timestamp startTime로 받고 mariadb의 time 타입으로 저장가능
			return date.toISOString();
		}
		return null;
	}
	
	/**
	 * 경과시간(초)를 문자열(hh:mm)로 변경한다
	 */
	static msToTime(duration) 
	{
        var minutes = parseInt((duration/(1000*60))%60);
        var hours = parseInt((duration/(1000*60*60))%24);

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        //seconds = (seconds < 10) ? "0" + seconds : seconds;
        //return hours + ":" + minutes + ":" + seconds;
		return hours + ":" + minutes;
    }

	/**
	 * 경과시간(초)를 문자열(hh:mm:ss)로 변경한다
	 */
	static secToTime(duration) 
	{ 
		var seconds = Math.floor(duration % 60), minutes = Math.floor((duration / 60) % 60), hours = Math.floor((duration / (60 * 60)) % 24); 
		
		hours = (hours < 10) ? "0" + hours : hours; 
		minutes = (minutes < 10) ? "0" + minutes : minutes; 
		seconds = (seconds < 10) ? "0" + seconds : seconds; 
		return hours + ":" + minutes + ":" + seconds; 
	}

	/**
	 * object 타입의 날짜를 문자열(yyyy-mm-dd)로 변경한다
	 */
	static getDateString (_date) 
	{
		if(typeof _date != 'object' || !(_date instanceof Date))
			return;

		_date.setHours(0,0,0,0);
		let year = _date.getFullYear();
		let month = _date.getMonth() + 1;
		let date = _date.getDate();

		if(month < 10) month = '0' + month;
		if(date < 10) date = '0'+ date;

		return year + '-' + month + '-' + date;
	}

	/**
	 * 현재 시간을 반환
	 * format: hh:mm:ss.xxx
	 */
	static getTimeString () 
	{
		const now = new Date(); // 현재 시간
		const utcNow = now.getTime() + (now.getTimezoneOffset() * 60 * 1000); // 현재 시간을 utc로 변환한 밀리세컨드값
		const koreaTimeDiff = 9 * 60 * 60 * 1000; // 한국 시간은 UTC보다 9시간 빠름(9시간의 밀리세컨드 표현)
		const koreaNow = new Date(utcNow + koreaTimeDiff); // utc로 변환된 값을 한국 시간으로 변환시키기 위해 9시간(밀리세컨드)를 더함
		return (koreaNow.getHours() < 10 ? '0' + koreaNow.getHours() : koreaNow.getHours() + ':' + koreaNow.getMinutes() + ':' + koreaNow.getSeconds() + '.' + koreaNow.getMilliseconds()).toString();
	}

	/**
	 * object 타입의 날짜를 문자열(yyyymmdd)로 변경한다
	 */
	static getDateyyyymmddString (_date) 
	{
		if(typeof _date != 'object' || !(_date instanceof Date))
			return;

		_date.setHours(0,0,0,0);
		let year = _date.getFullYear();
		let month = _date.getMonth() + 1;
		let date = _date.getDate();

		if(month < 10) month = '0' + month;
		if(date < 10) date = '0'+ date;

		return year + month + date;
	}

	/**
	 * object 타입의 날짜를 문자열(yyyy-mm)로 변경한다
	 */
	static getYMString (_date) 
	{
		if(typeof _date != 'object' || !(_date instanceof Date))
			return;

		_date.setHours(0,0,0,0);
		let year = _date.getFullYear();
		let month = _date.getMonth() + 1;
		let date = _date.getDate();

		if(month < 10) month = '0' + month;
		if(date < 10) date = '0'+ date;

		return year + '-' + month;
	}

	/**
	 * object 타입의 날짜를 문자열(mm/dd)로 변경한다
	 */
	static getDateString2 (_date) 
	{
		if(typeof _date != 'object' || !(_date instanceof Date))
			return;

		_date.setHours(0,0,0,0);
		let month = _date.getMonth() + 1;
		let date = _date.getDate();

		if(month < 10) month = '0' + month;
		if(date < 10) date = '0'+ date;

		return month + '/' + date;
	}

	/**
	 * YYYYMMDD에서 YYYY-MM-DD로 날짜 변경
	 */
	static convertDateString (_str) {
		if(_str == null || _str.length == 0) 
			return;
		return _str.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
	}

	/**
	 * 값이 비워있는 지 체크한다
	 */
	static isEmpty (value)
	{
		//return (value === undefined || value == null || value.length <= 0) ? true : false;
		return (
			// null or undefined
			(value == null) ||		

			// has length and it's zero
			//(value.hasOwnProperty('length') && value.length === 0) ||		
			(Object.prototype.hasOwnProperty.call(value, 'length') && value.length === 0) ||		

			// is an Object and has no keys
			(value.constructor === Object && Object.keys(value).length === 0)
		)
	}

	/**
	 * object 값을 받아서 value 값에 null 값으로 치환 하여 object를 다시 반환 한다
	 * 다차원 object 사용가능
	 * 사용 예) BomPage
	 */
	static setNull(input)
	{
		for(var key in input ){
			if(typeof input[key] != "object" ){
				if(input[key] != null){
					input[key] = null;
				}
			}else{
				// 다차원 배열로 인한 재귀처리
				this.setNull(input[key]);
			}
		}
		return input;
	}

	/**
	 * Object Rename Key
	 */
	static renameKeys = (obj, newKeys) => {
		const keyValues = Object.keys(obj).map(key => {
			const newKey = newKeys[key] || key;
			return { [newKey]: obj[key] };
		});
		return Object.assign({}, ...keyValues);
	}

	/**
	 * 엑셀의 날짜를 문자열(YYYY-MM-DD)로 변환한다
	 */
	static ExcelDateToJSDate = (serial) => {
		var utc_days  = Math.floor(serial - 25569);
		var utc_value = utc_days * 86400;                                        
		var date_info = new Date(utc_value * 1000);

		var fractional_day = serial - Math.floor(serial) + 0.0000001;
		var total_seconds = Math.floor(86400 * fractional_day);
		var seconds = total_seconds % 60;

		total_seconds -= seconds;
		var hours = Math.floor(total_seconds / (60 * 60));
		var minutes = Math.floor(total_seconds / 60) % 60;

		return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
	}

	/**
	 * 엑셀의 날짜를 문자열(YYYY-MM-DD)로 변환한다
	 */
	static ExcelDateToJSDate2 = (serial) => {
		return JsUtils.getDateString(JsUtils.ExcelDateToJSDate(serial));
	}

	/**
	 * 엑셀의 날짜를 문자열(YYYYMMDD)로 변환한다
	 */
	static ExcelDateToJSDate3 = (serial) => {
		return JsUtils.getDateyyyymmddString(JsUtils.ExcelDateToJSDate(serial));
	}
	
	/**
	 * table의 html 내용을 그대로 엑셀 파일로 다운로드 한다
	 */
	static downloadExcel = (ds) => {
		const workBook = XLSX.utils.book_new();     //  workbook 즉, 엑셀 파일을 하나 만든다
		const workSheet = XLSX.utils.json_to_sheet(ds) ; //  json 데이터를 worksheet 형태로 변환한다
		//alert(JSON.stringify(XLSX.utils.json_to_sheet(ds)));
		XLSX.utils.book_append_sheet(workBook, workSheet, 'download');  // sheet을 book에다 넣는다. 이때, sheet의 이름도 정한다
		XLSX.writeFile(workBook, 'download.xlsx');  // 엑셀 파일을 다운로드 한다. 이때, 엑셀 파일의 이름도 지정한다(확장자까지 포함).
	}   
	
	/**
	 * table의 html 내용을 그대로 엑셀 파일로 다운로드 한다
	 */
	static downloadExcel2 = (id) => {
		const workBook = XLSX.utils.book_new();     //  workbook 즉, 엑셀 파일을 하나 만든다
		const workSheet = XLSX.utils.table_to_sheet(document.getElementById(id)); //  table id를 넣어주고 html table 그대로 worksheet 형태로 변환한다
		XLSX.utils.book_append_sheet(workBook, workSheet, 'download');  // sheet을 book에다 넣는다. 이때, sheet의 이름도 정한다
		XLSX.writeFile(workBook, 'download.xlsx');  // 엑셀 파일을 다운로드 한다. 이때, 엑셀 파일의 이름도 지정한다(확장자까지 포함).
	}

	// static downloadExcel3 = (ds, heading) => {
	// 	//alert(heading);
	// 	const workBook = XLSX.utils.book_new();     //  workbook 즉, 엑셀 파일을 하나 만든다
	// 	const workSheet = XLSX.utils.json_to_sheet(ds) ; //  json 데이터를 worksheet 형태로 변환한다
	// 	//XLSX.utils.sheet_add_aoa(workSheet, heading);
	// 	XLSX.utils.sheet_add_json(workSheet, heading);
	// 	XLSX.utils.sheet_add_json(workSheet, ds, {orgin:'A2', skipHeader: true});
	// 	XLSX.utils.book_append_sheet(workBook, workSheet, 'download');  // sheet을 book에다 넣는다. 이때, sheet의 이름도 정한다
	// 	//XLSX.workBook = {Sheets:{'data':workSheet},SheetNames:['data']};
	// 	XLSX.writeFile(workBook, 'download.xlsx');  // 엑셀 파일을 다운로드 한다. 이때, 엑셀 파일의 이름도 지정한다(확장자까지 포함).
	// }   

	/**
	 * DB에 blob로 저장되어 있는 것을 byte[]로 받으면 bases64인코딩 되어서 받아져 이것을 디코딩하여 다시 byte []로 처리후 웹에서 읽을 수 있는 blob로 변환하여 주소로 보여준다
	 */
	static byteConvertoImg = (imgData) => {
		var blob = new Blob([this.base64TobyteArray(imgData)], {type: 'image/png'});
		return URL.createObjectURL(blob);
	}

	/**
	 * bases64로 인코인된 것을 byte로 변환한다
	 */
	static base64TobyteArray = (base64) => {
		var binary_string = atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes;
	}

	/**
	 * 금액 등 정수형 값을 천단위로 콤마(,) 표시한다
	 * 사용 예) JsUtils.formatToPrice(12345678);
	 */
	static formatToPrice = (value) => {
		var num = Number(value).toFixed(0);
		return `${Number(num).toLocaleString()}`; // "ko-KR"
	}

	/**
	 * 천단위로 콤마(,) 표시하면서 소수점 이하 n자리까지만 표시한다
	 * 사용 예) JsUtils.formatToPriceFixed(12345678.1234, 2);
	 */
	static formatToPriceFixed = (value, n) => {
		var num = Number(value).toFixed(n);
		return `${Number(num).toLocaleString()}`; // "ko-KR"
	}
}